import React, { Component } from 'react';
import Select, { components } from 'react-select';

const SelectContainer = ({ children, ...props }) => (
    <components.SelectContainer {...props}>
        <div className="react-select-search">
            {children}
        </div>
    </components.SelectContainer>
);

export default SelectContainer;